import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Box, ButtonDropdown, Container, Grid, Header, KeyValuePairs, SpaceBetween, Spinner, Tabs } from "@amzn/awsui-components-react";
const EmbedFlexicoParams = (props) => {
  const [params, setParams] = useState([])
  
  useEffect(() => {
    if(props?.transactionInfo && props?.flexicoTemplateInfo){
      processFlexicoParams(props.transactionInfo, props.flexicoTemplateInfo)
    }
  }, [props?.transactionInfo, props?.flexicoTemplateInfo])

  function processFlexicoParams(transactionInfo, flexicoTemplateInfo){
    const labelObject = flexicoTemplateInfo.parameters.reduce((acc, param) => {
      acc[param.label] = param;
      return acc;
    }, {});
    if(transactionInfo.plainParameters || transactionInfo.parameters){
      let parameters = JSON.parse(transactionInfo.plainParameters) || JSON.parse(transactionInfo.parameters)
      let paramObject = []
      Object.keys(parameters).forEach((key) => {
        if (labelObject[key] && !labelObject[key].is_hidden) {
          paramObject.push({
            'label': labelObject[key].display_name,
            'value': parameters[key]
          })
        }
      })
      setParams(paramObject)
    }
  }

  return (<Container
    header={<Header
      variant="h3"
      description="Parameters chosen while execution"
    >
      Input
    </Header>} >
    <KeyValuePairs
      columns={3}
      items={params}
    />
  </Container>)

}

export default EmbedFlexicoParams;
